import { render } from "./AllGame.vue?vue&type=template&id=e8ef47ea&scoped=true"
import script from "./AllGame.vue?vue&type=script&lang=js"
export * from "./AllGame.vue?vue&type=script&lang=js"

import "./AllGame.vue?vue&type=style&index=0&id=e8ef47ea&scoped=true&lang=css"

import exportComponent from "/home/runner/work/admin_6_0/admin_6_0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8ef47ea"]])

export default __exports__